import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The 18th in a series of annual conferences on the petroleum geology of Africa
was held at the  London Olympia, October 1-2. The series, organised by the
Petroleum Exploration Society of  Great Britain (PESGB) and the Geological
Society of Houston, alternates between these two cities.  The Olympia meeting
was attended by over 500 delegates who followed two days of presentations,
posters and an industry exhibition. Colin Reeves presented his most recent work
on a plate tectonic model for the dispersion of the other Gondwana continents
from around Africa. A new  discovery is the plate-tectonic role of a
coast-to-coast Mwembishi shear zone stretching 3200 km  from Namibia to
Tanzania, passing through parts of seven African countries. It was active as a
dextral strike-slip feature in Early Cretaceous time (135-129 Ma). `}</p>
    <p>{`The focus of the presentation is the concentration of a number of plate-tectonic
events around  southern Africa into this short time interval (Hauterivian) which
Colin calls the 'Second Gondwana  disruption event', following the first event
with the outbreak of extensive volcanism at around 183  Ma (Pliensbachian). `}</p>
    <p>{`Recently-published marine magnetic anomaly data off Mozambique and its conjugate
margin of  Antarctica (Mueller & Jokat, 2019) show that a distinct 'sidestep' in
the southward progress of  Antarctica against Africa occurred from 135 to 129
Ma. At the start of this interval was a mid ocean ridge reorganisation off the
SE corner of Africa and the outbreak of the Tristan plume in the  central South
Atlantic Ocean. While the opening of the southernmost South Atlantic had already
been underway for about 10 myr at the time, post-135 Ma dextral movement on the
Mwembishi  shear zone could delay opening of the South Atlantic south of Walvis
Bay by several million years,  making a 1000 km stretch of margin north of the
Orange River mouth the last part of the South  Atlantic to open. By 129 Ma,
however, incipient ocean was continuous all the way from Nigeria to  Western
Australia. `}</p>
    <p>{`Copies of the Powerpoint from Colin's presentation are available on request from
the author at  `}<a parentName="p" {...{
        "href": "mailto:reeves.earth@planet.nl."
      }}>{`reeves.earth@planet.nl.`}</a>{` The full four-page abstract of the
presentation (with figures) may be  downloaded `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`here`}</a>{`. `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      